import { render, staticRenderFns } from "./GradeExamReport.vue?vue&type=template&id=fbb419ea&scoped=true&"
import script from "./GradeExamReport.vue?vue&type=script&lang=js&"
export * from "./GradeExamReport.vue?vue&type=script&lang=js&"
import style0 from "./GradeExamReport.vue?vue&type=style&index=0&id=fbb419ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb419ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
